import { createActions } from 'redux-actions'

export const { loadingStart, loadingEnd } = createActions({
  LOADING_START: () => {},
  LOADING_END: () => {},
})
